import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { DialogContent as KitDialogContent } from '@vnetwork/ui/primitives';
import { composeInteractOutside } from './toast-options';

type KitProps = ComponentPropsWithoutRef<typeof KitDialogContent>;

/**
 * The console's `DialogContent`: the kit's, plus a dialog that stays open when the interaction outside it is with a toast
 * (a click on its Dismiss). Radix reports a click on a toast as "outside" and closes the dialog, losing the form; doing it here
 * once gives every dialog the rule. Import it from here, never from `@vnetwork/ui/primitives` (tests/organizations scan).
 */
export const DialogContent = forwardRef<ElementRef<typeof KitDialogContent>, KitProps>(function DialogContent(
  { onInteractOutside, ...rest },
  ref,
) {
  return (
    <KitDialogContent
      ref={ref}
      {...rest}
      onInteractOutside={composeInteractOutside(onInteractOutside)}
    />
  );
});
